import hapticsOnPress from '@/utils/hapticsOnPress';
import isDesktopUserAgent from '@/utils/isDesktopUserAgent';

export default function useHaptics<TArgs extends unknown[]>(
  fn?: (...args: TArgs) => void,
) {
  const callback = (...args: TArgs) => {
    fn?.(...args);
  };

  if (isDesktopUserAgent) {
    return callback;
  }

  return hapticsOnPress(callback);
}
